module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"title":{"ja":"お役立ちコンテンツ","en":"Tips & Hints"},"description":"WareX（ウェアエックス）のお役立ちコンテンツ一覧ページ{page}です。倉庫利用にまつわる基礎知識やお役立ち情報をご確認いただけます。WareXは契約からご利用まで、サポート対応も充実した、新しい倉庫利用サービスです。","page":"{num}ページ目","search":{"title":"目的から探す"}}}')
  delete Component.options._Ctor
}
